import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import './style.css';

const ResponsiveFlexGrid = (props) => {
  const widgetClassList = ['o-widget', 'c-responsive-flex-grid'];
  widgetClassList.push(
    (props.fields?.LayoutType?.name && props.fields.LayoutType.name.toLowerCase()) ||
      'grid-33-33-33'
  );

  return (
    <div className={widgetClassList.join(' ')}>
      <Placeholder name="responsive-flex-grid" rendering={props.rendering} />
    </div>
  );
};

export default ResponsiveFlexGrid;
